// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const milestone = defineModel({
  id: "milestone",
  batchId: "future",
  name: "Milestone",
  tags: ["scenery","milestone","low-poly","age-of-mcp","future"],
  summary: "A waystone marking road distance — orientation for hauliers.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.25,
  parts: () => [
      { geometry: new THREE.CylinderGeometry(0.13, 0.18, 0.5, 6), color: "#9a958a", position: [0.02, 0.25, 0], rotation: [0, 0.4, 0.08] },
      { geometry: new THREE.SphereGeometry(0.13, 8, 5, 0, 6.283185, 0, 1.570796), color: "#9a958a", position: [0.04, 0.5, 0], rotation: [0, 0, 0.08] },
      { geometry: new THREE.CylinderGeometry(0.15, 0.16, 0.06, 6), color: "#b24a3a", position: [0.025, 0.31, 0], rotation: [0, 0.4, 0.08] },
      { geometry: new THREE.CylinderGeometry(0.2, 0.22, 0.06, 8), color: "#7c776c", position: [0, 0.03, 0] },
    ],
  animations: [],
});
